/**
 * Created by portiz on 8/23/2018.
 */
import React from 'react';
import { Input, FormGroup, Col, Label, Alert } from 'reactstrap';
import Validator from '../../custom-classes/validator';
/** Multiple Language imports **/
import { Translate } from "react-localize-redux";
/** End of Multiple Language imports **/

/**
 * The form group to manage the phone.
 * Includes an alert to validates the phone and the main function to update the parent phoe
 */
class FormGroupPhone extends React.Component{

    constructor(props){
        // Super is always called when defining the constructor of a subclass
        // All React component classes that have a constructor, should start it with a super(props) call.
        super(props);
        this.state =
        {
            validPhone: true,
            phone: ''
        }; // Default value

        if(this.props.data)
        {
            this.state =
            {
                phone: this.props.data.phone,
                validPhone: true
            }; // Default value
        }

        this.handlePhoneChange = this.handlePhoneChange.bind(this);
    }

    /**
     * If the props are not null, set the values
     * @param nextProps
     */
    componentWillReceiveProps(nextProps){

        if(typeof nextProps.data !== 'undefined'){
            this.setState({
                phone: nextProps.data.phone
            });
        }
    }

    /**
     * Handles the phone change and send the phone to the parent
     * @param event
     */
    handlePhoneChange(event){
        this.setState({phone: event.target.value}, () => {
                // Check if address is valid
                this.setState({validPhone: Validator.isPhoneValid(this.state.phone)}, () =>
                {
                    this.props.updateParent(this.state);
                    return this.state;
                });
            }
        ); // This has a callback to evaluate the warning. If we don't use a callback, is not going to read the
        // last character while we are checking if they are equal or not
    }

    /**
     * Renders the phone group
     * @returns {XML}
     */
    render() {
        return (
            <div>
                <FormGroup row>
                    <Col sm={{ size: 10, offset: 1 }}>
                        <Label for="phone">
                            <Translate id="register.phone" options={{renderInnerHtml: true}}/>
                        </Label>
                        <Input value={this.state.phone} type="tel" name="phone" id="phone" onChange={this.handlePhoneChange} />
                    </Col>
                </FormGroup>
                {
                    !this.state.validPhone ?
                    <FormGroup row>
                        <Col sm={{ size: 10, offset: 1 }}>
                            <Alert color="danger" isOpen={!this.state.validPhone}>
                                <Translate id="register.phone-error" options={{renderInnerHtml: true}}/>
                            </Alert>
                        </Col>
                    </FormGroup> : null
                }
            </div>
        )
    };
}

export default FormGroupPhone;


// WEBPACK FOOTER //
// ./src/components/forms/form-group-phone.js